// Alto del encabezado fijo de la app (HeaderWithDropdown): una sola fila,
// 56 px en teléfonos y 64 px desde sm. Los layouts reservan EXACTAMENTE este
// espacio arriba del contenido (AdminHomeLayout, LayoutApp); si el
// encabezado crece (p. ej. pasa a dos filas) tapa el título de las páginas.
export const HEADER_HEIGHT = { xs: 56, sm: 64 };
